import moment from 'moment';

export const extrapolateTimesheetEntries = (
    personIds: number[],
    startDate: string,
    endDate: string,
    data: any
): any => {
    const numberOfDays = moment(endDate, 'YYYY-MM-DD').diff(
        moment(startDate, 'YYYY-MM-DD'),
        'days'
    );

    return personIds.reduce((accumulator: any[], personId): any => {
        for (let day = 0; day <= numberOfDays; day += 1) {
            accumulator.push({
                ...data,
                date: moment(startDate)
                    .add(day, 'days')
                    .format('YYYY-MM-DD'),
                personId,
                uuid: undefined
            });
        }

        return accumulator;
    }, []);
};
